import auth0 from 'auth0-js'

export default class Authenticator {
  constructor () {
    this.auth0 = new auth0.WebAuth({
      domain: 'pmconnect.eu.auth0.com',
      redirectUri: `${window.location.origin}/callback`,
      clientID: 'U7ZjAOg67qYLZyOW9vL9ZhJLSlS9TxvI',
      audience: 'games-api.service',
      responseType: 'token id_token'
    })
  }

  login () {
    this.auth0.authorize()
  }

  handleAuthentication () {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err) return reject(err)

        resolve(authResult)
      })
    })
  }

  checkSession () {
    return new Promise((resolve, reject) => {
      this.auth0.checkSession({}, function (err, authResult) {
        if (err) return reject(err)

        resolve(authResult)
      })
    })
  }
}
